(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const money = (cents, currency = 'CZK') => new Intl.NumberFormat(currency === 'CZK' ? 'cs-CZ' : document.documentElement.lang || 'cs-CZ', {
    style: 'currency', currency, maximumFractionDigits: currency === 'CZK' ? 0 : 2
  }).format(Number(cents || 0) / 100);
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));

  async function cartRequest(endpoint, body) {
    const response = await fetch(`${root()}cart/${endpoint}.js`, {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Košík se nepodařilo aktualizovat.');
    return data;
  }

  function initHeader() {
    const header = document.querySelector('[data-oa-header]');
    if (!header || header.dataset.oaReady) return;
    header.dataset.oaReady = 'true';
    const scrim = document.querySelector('[data-oa-scrim]');
    const drawers = [...document.querySelectorAll('[data-oa-drawer]')];
    const cartDrawer = document.querySelector('[data-oa-drawer="cart"]');
    let lastFocus;

    function close() {
      drawers.forEach(drawer => { drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); });
      scrim?.classList.remove('on');
      document.body.style.overflow = '';
      lastFocus?.focus();
    }
    function open(name) {
      close();
      lastFocus = document.activeElement;
      const drawer = drawers.find(item => item.dataset.oaDrawer === name);
      if (!drawer) return;
      drawer.classList.add('on');
      drawer.setAttribute('aria-hidden', 'false');
      scrim?.classList.add('on');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('button, a, input')?.focus();
      if (name === 'cart') refreshCart();
    }

    async function refreshCart() {
      if (!cartDrawer) return;
      const list = cartDrawer.querySelector('[data-oa-cart-items]');
      const footer = cartDrawer.querySelector('[data-oa-cart-footer]');
      try {
        const response = await fetch(`${root()}cart.js`);
        if (!response.ok) throw new Error('Košík se nepodařilo načíst.');
        const cart = await response.json();
        const currency = cart.currency || cartDrawer.dataset.currency || 'CZK';
        document.querySelectorAll('[data-oa-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          if (el.classList.contains('dot')) el.classList.toggle('on', cart.item_count > 0);
        });
        footer.hidden = cart.item_count === 0;
        if (!cart.item_count) {
          list.innerHTML = '<p class="sm" style="padding:48px 0;text-align:center">Košík je prázdný.</p>';
          return;
        }
        list.innerHTML = cart.items.map(item => `
          <div class="cl">
            <div class="m" style="aspect-ratio:1">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}</div>
            <div>
              <div style="display:flex;justify-content:space-between;gap:10px">
                <div><p class="oa-cart-line-title">${escapeHtml(item.product_title)}</p><p class="xs oa-cart-line-meta">${escapeHtml(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p></div>
                <p class="oa-cart-line-title num">${money(item.final_line_price, currency)}</p>
              </div>
              <div class="oa-cart-line-actions"><span class="qt">
                <button type="button" data-oa-change="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Ubrat">−</button><span>${item.quantity}</span><button type="button" data-oa-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Přidat">+</button>
              </span><button class="xs" type="button" data-oa-change="${escapeHtml(item.key)}" data-quantity="0" style="text-decoration:underline">Odebrat</button></div>
            </div>
          </div>`).join('');
        cartDrawer.querySelector('[data-oa-cart-total]').textContent = money(cart.total_price, currency);
        const progress = cartDrawer.querySelector('[data-oa-shipping-progress]');
        const threshold = Number(cartDrawer.dataset.freeShipping || 0);
        if (threshold > 0) {
          const left = Math.max(0, threshold - cart.total_price);
          progress.innerHTML = `<p class="xs">${left ? `Do dopravy zdarma zbývá ${money(left, currency)}` : 'Doprava zdarma'}</p><div class="pb"><i style="width:${Math.min(100, cart.total_price / threshold * 100)}%"></i></div>`;
        } else progress.innerHTML = '';
      } catch (error) {
        list.innerHTML = `<p class="oa-cart-error">${escapeHtml(error.message)}</p><a class="u" href="${root()}cart">Otevřít košík</a>`;
      }
    }

    header.querySelectorAll('[data-oa-open]').forEach(button => button.addEventListener('click', () => open(button.dataset.oaOpen)));
    document.querySelectorAll('[data-oa-close]').forEach(button => button.addEventListener('click', close));
    scrim?.addEventListener('click', close);
    document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    cartDrawer?.addEventListener('click', async event => {
      const button = event.target.closest('[data-oa-change]');
      if (!button) return;
      button.disabled = true;
      try { await cartRequest('change', {id: button.dataset.oaChange, quantity: Number(button.dataset.quantity)}); await refreshCart(); }
      catch (error) { button.disabled = false; cartDrawer.querySelector('[data-oa-cart-items]').insertAdjacentHTML('afterbegin', `<p class="oa-cart-error">${escapeHtml(error.message)}</p>`); }
    });
    window.OnauraCart = {open: () => open('cart'), refresh: refreshCart};
    refreshCart();

    const ticker = document.querySelector('[data-oa-ticker]');
    const notices = [...(ticker?.querySelectorAll('.tk__i') || [])];
    if (notices.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let index = 0;
      setInterval(() => { notices[index].classList.remove('on'); index = (index + 1) % notices.length; notices[index].classList.add('on'); }, 5200);
    }
  }

  function initProduct() {
    const section = document.querySelector('[data-oa-product]');
    if (!section || section.dataset.oaReady) return;
    section.dataset.oaReady = 'true';
    const form = section.querySelector('.oa-product-form');
    const input = section.querySelector('[data-oa-variant-input]');
    const add = section.querySelector('[data-oa-add]');
    const variants = [...section.querySelectorAll('[data-oa-variant]')];
    const currency = section.dataset.currency || 'CZK';
    const error = section.querySelector('[data-oa-product-error]');
    const packageButtons = [...section.querySelectorAll('[data-oa-package]')];
    const duoGroups = [...section.querySelectorAll('[data-oa-duo-group]')];
    const duoPrice = Number(section.dataset.oaDuoPrice);
    let packageType = 'single';
    let selectedSingle = variants.find(button => button.dataset.id === input?.value) || variants[0];
    const selectedDuo = duoGroups.map(group => variants.find(button => button.dataset.id === group.querySelector('[aria-checked="true"]')?.dataset.id) || selectedSingle);

    function dots() {
      const gallery = [...section.querySelectorAll('.gt')].find(el => !el.hidden);
      const holder = section.querySelector('[data-oa-gallery-dots]');
      if (!gallery || !holder) return;
      const images = [...gallery.children];
      holder.innerHTML = images.map((_, index) => `<b class="${index ? '' : 'on'}"></b>`).join('');
      gallery.onscroll = () => {
        const index = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth * .88));
        holder.querySelectorAll('b').forEach((dot, i) => dot.classList.toggle('on', i === Math.min(index, images.length - 1)));
      };
    }
    function render(updateUrl = true) {
      const duo = packageType === 'duo';
      const active = duo ? selectedDuo[0] : selectedSingle;
      if (!active) return;
      const price = duo ? duoPrice : Number(active.dataset.price);
      const comparePrice = duo ? selectedDuo.reduce((total, variant) => total + Number(variant.dataset.price), 0) : Number(active.dataset.compare);
      const sameVariant = duo && selectedDuo[0]?.dataset.id === selectedDuo[1]?.dataset.id;
      const available = duo ? selectedDuo.every(variant => variant?.dataset.available === 'true') && (!sameVariant || selectedDuo[0].dataset.tracked !== 'true' || Number(selectedDuo[0].dataset.inventory) >= 2) : active.dataset.available === 'true';
      input.value = active.dataset.id;
      section.querySelector('[data-oa-price]').textContent = money(price, currency);
      section.querySelector('[data-oa-duo-price-text]').textContent = money(duoPrice, currency);
      const compare = section.querySelector('[data-oa-compare]');
      compare.hidden = comparePrice <= price;
      compare.textContent = money(comparePrice, currency);
      const savings = section.querySelector('[data-oa-savings]');
      savings.hidden = !duo || comparePrice <= price;
      savings.textContent = `Ušetříš ${money(comparePrice - price, currency)}`;
      add.disabled = !available;
      add.textContent = available ? `Přidat do košíku — ${money(price, currency)}` : 'Vyprodáno';
      section.querySelector('[data-oa-sticky-variant]').textContent = `${duo ? selectedDuo.map(variant => variant.dataset.title).join(' + ') : active.dataset.title} · ${money(price, currency)}`;
      section.querySelector('[data-oa-sticky-add]').disabled = !available;
      const color = active.dataset.title.toLowerCase().includes('rose') ? 'rose' : 'chalk';
      section.querySelectorAll('[data-oa-gallery]').forEach(gallery => { if (gallery.dataset.oaGallery) gallery.hidden = gallery.dataset.oaGallery !== color; });
      dots();
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', active.dataset.id);
        url.searchParams.delete('color');
        history.replaceState(null, '', url);
      }
    }
    function selectSingle(button, updateUrl = true) {
      if (!button) return;
      selectedSingle = button;
      variants.forEach(item => item.setAttribute('aria-checked', String(item === button)));
      section.querySelector('[data-oa-selected-name]').textContent = button.dataset.title;
      section.querySelector('[data-oa-single-price]').textContent = money(button.dataset.price, currency);
      render(updateUrl);
    }
    variants.forEach(button => button.addEventListener('click', () => selectSingle(button)));
    duoGroups.forEach((group, index) => {
      group.querySelectorAll('[data-oa-duo-variant]').forEach(button => button.addEventListener('click', () => {
        selectedDuo[index] = variants.find(variant => variant.dataset.id === button.dataset.id);
        group.querySelectorAll('[data-oa-duo-variant]').forEach(item => item.setAttribute('aria-checked', String(item === button)));
        group.querySelector('[data-oa-duo-name]').textContent = selectedDuo[index].dataset.title;
        render();
      }));
    });
    packageButtons.forEach(button => button.addEventListener('click', () => {
      packageType = button.dataset.oaPackage;
      packageButtons.forEach(item => item.setAttribute('aria-checked', String(item === button)));
      const singleColor = section.querySelector('[data-oa-single-color]');
      if (singleColor) singleColor.hidden = packageType === 'duo';
      section.querySelector('[data-oa-duo]').hidden = packageType !== 'duo';
      render();
    }));
    [section.querySelector('[data-oa-single-color] .sws'), ...duoGroups, section.querySelector('.op')].filter(Boolean).forEach(group => group.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const buttons = [...group.querySelectorAll('[role="radio"]')];
      const current = buttons.indexOf(document.activeElement);
      const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = buttons[(current + step + buttons.length) % buttons.length];
      next?.focus();
      next?.click();
    }));
    const requestedColor = new URLSearchParams(location.search).get('color');
    if (requestedColor) selectSingle(variants.find(button => button.dataset.title.toLowerCase().includes(requestedColor.toLowerCase())));
    else selectSingle(selectedSingle, false);
    dots();
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (!input?.value || add.disabled) return;
      add.disabled = true;
      error.hidden = true;
      try {
        const items = packageType === 'duo'
          ? selectedDuo[0].dataset.id === selectedDuo[1].dataset.id
            ? [{id: Number(selectedDuo[0].dataset.id), quantity: 2}]
            : selectedDuo.map(variant => ({id: Number(variant.dataset.id), quantity: 1}))
          : [{id: Number(input.value), quantity: 1}];
        await cartRequest('add', {items});
        await window.OnauraCart?.refresh();
        window.OnauraCart?.open();
      } catch (cause) { error.textContent = cause.message; error.hidden = false; }
      finally { if (variants.length) render(false); else add.disabled = false; }
    });
    section.querySelector('[data-oa-sticky-add]')?.addEventListener('click', () => add.click());
    const sticky = section.querySelector('[data-oa-sticky-buy]');
    const buy = section.querySelector('[data-oa-buy]');
    const updateSticky = () => {
      const visible = buy.getBoundingClientRect().bottom < 40;
      sticky.classList.toggle('on', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    window.addEventListener('scroll', updateSticky, {passive: true});
    updateSticky();
  }

  function initStudio() {
    const section = document.querySelector('[data-oa-home]');
    if (!section || section.dataset.oaReady) return;
    section.dataset.oaReady = 'true';
    const form = section.querySelector('.oa-studio-form form');
    if (!form) return;
    const counts = {chalk: 3, rose: 2};
    let size = 5;
    const message = section.querySelector('[data-mix-message]');
    const quantity = section.querySelector('[data-studio-field="quantity"]');
    function render() {
      Object.entries(counts).forEach(([color, amount]) => { section.querySelector(`[data-mix-count="${color}"]`).textContent = amount; });
      const total = counts.chalk + counts.rose;
      message.textContent = total === size ? `Celkem ${total} z ${size} párů` : `Vybráno ${total} z ${size} párů`;
      message.style.color = total === size ? '' : 'var(--rose)';
    }
    section.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => {
      size = Number(button.dataset.size);
      section.querySelectorAll('[data-size]').forEach(item => item.setAttribute('aria-checked', String(item === button)));
      counts.chalk = Math.ceil(size / 2);
      counts.rose = size - counts.chalk;
      quantity.value = size;
      render();
    }));
    section.querySelectorAll('[data-mix]').forEach(button => button.addEventListener('click', () => {
      const color = button.dataset.mix;
      counts[color] = Math.max(0, counts[color] + Number(button.dataset.delta));
      render();
    }));
    form.addEventListener('submit', event => {
      if (counts.chalk + counts.rose !== Number(quantity.value)) {
        event.preventDefault();
        message.textContent = `Počet odstínů musí odpovídat počtu párů (${quantity.value}).`;
        message.style.color = 'var(--rose)';
        message.scrollIntoView({block: 'center', behavior: 'smooth'});
        return;
      }
      const field = name => section.querySelector(`[data-studio-field="${name}"]`)?.value.trim() || '';
      form.querySelector('[data-oa-studio-body]').value = `Studio: ${field('studio')}\nMěsto: ${field('city')}\nPočet párů: ${field('quantity')}\nChalk: ${counts.chalk}\nRose: ${counts.rose}\nPoznámka: ${field('note')}`;
    });
    render();
  }

  const init = () => { initHeader(); initProduct(); initStudio(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
